import { Flex } from "@aircall/tractor";
import styled from "@xstyled/styled-components";

export const Scrollbar = styled(Flex).attrs({
  flex: 1,
  py: "s",
  flexDirection: "column",
})<{ mobile: boolean }>`
  overflow: ${({ mobile }) => (mobile ? "initial" : "auto")};
  align-items: center;
`;
